<template>
    <div class="layout-dft-title-box">
        <div class="layout-dft-title">
            <!-- 天性图标 -->
            <span v-if="!isLocalDetail && shareId == ''" class="layout-dft-icon-talent" @click="clickNature">
                <i class="iconbg icon-talent" v-bind:class="{'icon-talent-org': hasAiCharacter}"></i>
                <span v-bind:class="{'red': (natureCharacterData.needpay == 1 || natureTalentData.needpay == 1) && natureTimeLimit > 0}">天性</span>
                <nature-time></nature-time>
            </span>
            <!-- 新版tab -->
            <span class="layout-dft-tab">
                <span class="layout-dft-tab-item" v-bind:class="{'cur': data.index == showDetailType}" v-for="data in tabList" :key="'tab' + data.text" @click="clickTab(data)">{{data.text}}</span>
            </span>
            <span class="layout-dft-icon-box">
                <!-- 百科图标 -->
                <i v-if="detailInfo.toBaike" class="iconfont icon-baike" @click.stop="clickBaiKe"></i>
                <!-- 切换模式图标 -->
                <i v-if="showDetailType == 1" class="iconfont icon-table" @click.stop="clickToggleTable"></i>
                <!-- 设置图标 -->
                <i class="iconfont icon-setting layout-dft-icon" @click.stop="clickSetting"></i>
            </span>
        </div>
    </div>
</template>

<script>
import NatureTime from '../../layouts/nature/NatureTime.vue'
import { LOADING_DOM } from '../../modules/dom'
import { MIX } from '../../modules/utils'
export default {
    name: 'DetailTabBar',
    components: { NatureTime },
    computed: {
        shareId() {
            return this.$store.state.share.shareId
        },
        detailInfo() {
            return this.$store.state.detail.personInfo
        },
        isLocalDetail() {
            return this.$store.state.detail.isLocalDetail;
        },
        showDetailType() {
            return this.$store.state.detail.showDetailType
        },
        hasAiCharacter() {
            return this.$store.state.report.hasAiCharacter
        },
        natureCharacterData() {
            return this.$store.state.report.natureCharacterData;
        },
        natureTalentData() {
            return this.$store.state.report.natureTalentData;
        },
        natureTimeLimit() {
            return this.$store.state.report.natureTimeLimit;
        }
    },
    data(){
        return {
            tabList: [
                {text: '资料', index: 0, type: 'info'},
                {text: '流运', index: 1, type: 'liuyun'},
                {text: '神煞', index: 2, type: 'shensha'},
                {text: '合化', index: 3, type: 'relation'},
            ]
        }
    },
    methods: {
        clickNature() {
            MIX.trackButtonClicked('mingpan_talent');
            this.$bus.emit('clearDetailNatureTime');
            var curParams = this.$router.history.current.params;
            this.$router.replace('/nature/'+curParams.from+'/'+curParams.id);
        },
        clickTab(data){
            if(data.index == 0) {
                MIX.trackButtonClicked('mingpan_bz_info');
            }else if(data.index == 1) {
                MIX.trackButtonClicked('mingpan_bz_liuyun');
                this.$bus.emit('updateDetailDom');
            }else if(data.index == 2){
                MIX.trackButtonClicked('mingpan_bz_shengsha');
                // 处理神煞数据
                this.$store.dispatch('detail/initDetailShensha');
            }else if(data.index == 3){
                // 处理合化冲数据
                MIX.trackButtonClicked('mingpan_bz_hehuachong');
                this.$store.dispatch('detail/initDetailHehuachong');
                var curpath = this.$router.history.current.path;
                    curpath = curpath + '/hehuachong';
                this.$router.push({
                    path: curpath
                })
            }
            if(data.index != 3) {
                this.$store.state.detail.showDetailType = data.index;
            }
        },
        clickBaiKe() {
            LOADING_DOM.showLoading();
            var me = this,
                baikeId = this.detailInfo.toBaike,
                curpath = this.$router.history.current.path;
            curpath = curpath.slice(1);
            curpath = curpath.replace(/\//g, '_');

            this.$bus.emit('clearDetailNatureTime');
            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('search/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            this.$store.dispatch('famouspedia/initBaikeInfo', {
                fromDetail: true,
                baikeId: baikeId,
                baikeType: 'hot',
                sucCb: function() {
                    me.$router.replace('/famouspediaread/' + baikeId+'/'+curpath)
                    LOADING_DOM.hideLoading();
                },
                failCb: function() {
                    me.$toast('没有找到这个八字的百科数据');
                    LOADING_DOM.hideLoading();
                }
            })
        },
        clickToggleTable() {
            MIX.trackButtonClicked('mingpan_shishen_switch');
            var showTable = this.$store.state.detail.fatefortune.showTable;
            this.$store.state.detail.fatefortune.showTable = showTable == 5 ? 10 : 5;
            this.$store.dispatch('detail/fatefortune/checkDetailFortuneData')
            this.$store.dispatch('setting/updateSettingData', {
                params: {
                    liuYunCount: showTable == 5 ? 1 : 0
                }
            });
        },
        clickSetting() {
            var curpath = this.$router.history.current.path;
                curpath = curpath + '/setui';
            // console.error('clickSetting------', curpath)
            this.$router.push({
                path: curpath
            })
        }
    }
}
</script>